import React from 'react'
import { Pie } from 'react-chartjs-2';

const KoleksiTerbacaTerbanyak = ({ chartDataKoleksiTerbacaTerbanyak }) => {
  return (
    <div className='chart-container'>
        <Pie
        data={chartDataKoleksiTerbacaTerbanyak}
        options={{ 
            plugins: {
                title: {
                    display: true,
                }
            }
         }}/>
    </div>
  )
}

export default KoleksiTerbacaTerbanyak